import React, { useState, useEffect, useRef } from "react";
import { deleteAllCookies } from "../../../util";

const LkNav = (props) => {
    const [hoverMenu, setHoverMenu] = useState(null);
    const [isHovered1, setIsHovered1] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);
    const [isHovered3, setIsHovered3] = useState(false);
    const [isHovered4, setIsHovered4] = useState(false);
    const [deliveryType, setDeliveryType] = useState(() => {
        return localStorage.getItem("delivery_type") || "auto";
    });

    const popoverRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                popoverRef.current &&
                !popoverRef.current.contains(event.target) &&
                buttonRef.current && !buttonRef.current.contains(event.target)
            ) {
                props.setIsPopoverOpen(false);
            }
        }

        if (props.isPopoverOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [props.isPopoverOpen]);

    useEffect(() => {
        localStorage.setItem("delivery_type", deliveryType);
    }, [deliveryType]);

    const handleMouseEnter1 = () => {
        setIsHovered1(true);

    };
    const handleMouseLeave1 = () => {
        setIsHovered1(false);
    };
    const handleMouseEnter2 = () => {
        setIsHovered2(true);

    };
    const handleMouseLeave2 = () => {
        setIsHovered2(false);
    };
    const handleMouseEnter3 = () => {
        setIsHovered3(true);

    };
    const handleMouseLeave3 = () => {
        setIsHovered3(false);
    };
    const handleMouseEnter4 = () => {
        setIsHovered4(true);

    };
    const handleMouseLeave4 = () => {
        setIsHovered4(false);
    };

    const handleDeliveryTypeChange = (type) => {
        setDeliveryType(type);
    };

    return (
        <div className={`h-[100vh] flex flex-col justify-between gap-[10px] py-[24px] px-[20px] text-[14px] transition-all duration-300`}>
            {/* ВЕРХ */}
            <div className="flex lg:justify-between justify-center">
                <img src={props.navOpen ? props.data.menuTop.logo1 : props.data.menuTop.logo2} alt="Logo" onClick={() => window.location.replace('/')} className="cursor-pointer" />
                <button className={`duration-300 rounded-[150px] p-[6px] hidden lg:block ${props.navOpen ? 'rotate-0' : 'rotate-180'} transition-transform`} onClick={props.ClickNavOpen}
                    style={{ background: props.data.menuTop.bgBtn }}>
                    <img src={props.data.menuTop.btnImage} alt="Toggle Menu" />
                </button>
            </div>

            {/* МЕНЮШКА */}
            <div className="py-[12px] rounded-[24px] transition-opacity duration-300"
                style={{ background: props.data.MenuColors.white }}>
                {props.data.LkMenu.map((item, index) => (
                    <div key={index}>
                        <a
                            href="#" // Замените на href="#" чтобы предотвратить переход, так как мы используем onClick
                            className={`flex items-center gap-[12px] px-[20px] py-[12px] ${props.activeMenu === index ? 'border-solid border-l-[4px]' : ''}`}
                            style={{ borderColor: props.data.MenuColors.red }}
                            onMouseEnter={() => setHoverMenu(index)}
                            onMouseLeave={() => setHoverMenu(null)}
                            onClick={() => {
                                props.setActiveMenu(index); // Устанавливаем активное меню
                            }}
                        >
                            <img src={hoverMenu === index || props.activeMenu === index ? item.imgHover : item.img} alt={item.title} />
                            <span className={`transition-opacity duration-300 ${props.navOpen ? 'opacity-100' : 'opacity-0'} ${props.navOpen ? 'block' : 'hidden'}`}>{item.title}</span>
                        </a>
                    </div>
                ))}
            </div>

            {/* СОЗДАТЬ НОВУЮ ЗАЯВКУ */}
            <div
                className="relative w-full z-50">
                <div

                    ref={buttonRef}
                    onClick={() => props.setIsPopoverOpen(!props.isPopoverOpen)}
                    className={`
                        cursor-pointer
                        w-full
                        py-[20px]
                        flex flex-col
                        items-center
                        gap-[10px]
                        bg-[${props.data.Menu_pop.bg}]
                        rounded-[24px]
                        border-dashed
                        border-[1px]
                    `}
                    style={{ borderColor: props.data.MenuNewApp.borderColor }}
                >
                    <div className="flex flex-col items-center gap-[10px]">
                        <div>
                            <img src={props.data.MenuNewApp.image} alt="New Application" />
                        </div>
                        <div
                            className={`
                                transition-opacity duration-300
                                ${props.navOpen ? "opacity-100 block" : "opacity-0 hidden"}
                            `}
                        >
                            {props.data.MenuNewApp.text}
                        </div>
                    </div>
                </div>

                {/* ----- ВСПЛЫВАЮЩЕЕ ОКНО -----
                Появляется при isPopoverOpen === true*/}
                <div
                    ref={popoverRef}
                    className={`
                        absolute
                        left-0 
                        top-0
                        mt-[-25px]
                        w-full
                        bg-[${props.data.Menu_pop.bg}]
                        rounded-[24px]
                        shadow-lg
                        transition-all
                        duration-300
                        flex
                        justify-center
                        origin-bottom
                        group
                        z-50
                        overflow-visible
                        border-[1px]
                        border-[${props.data.Menu_pop.border}]
                        ${props.isPopoverOpen
                            ? "scale-y-100 opacity-100 translate-y-[-100%]"
                            : "scale-y-0 opacity-0 translate-y-0"
                        }
                    `}
                >
                    {/* Стрелочка (указатель) */}
                    <div className={`flex justify-center
                            absolute

                            ${props.navOpen ? `top-[25px]` : `top-[192px]`}
                            w-[30px]
                            h-[30px]
                            bg-[${props.data.Menu_pop.bg}]
                            rotate-45
                            rounded-[3px]
                            -z-30
                            `}
                    />

                    <div className={`py-3 px-4 flex w-full ${props.navOpen ? `flex-row gap-0` : `flex-col gap-8`} items-center justify-around`}>
                        {/* Иконки транспорта */}
                        <button
                            onMouseEnter={handleMouseEnter1}
                            onMouseLeave={handleMouseLeave1}
                            onClick={() => handleDeliveryTypeChange("auto")}
                            className={deliveryType === "auto" ? "active-class" : ""}
                        >
                            <a href={props.data.Menu_pop.icons.truck.link}>
                                <img src={isHovered1 ? props.data.Menu_pop.icons.truck.imgHover : props.data.Menu_pop.icons.truck.img} alt="truck"
                                />
                            </a>
                        </button>
                        <button
                            onMouseEnter={handleMouseEnter2}
                            onMouseLeave={handleMouseLeave2}
                            onClick={() => handleDeliveryTypeChange("avia")}
                            className={deliveryType === "avia" ? "active-class" : ""}
                        >
                            <a href={props.data.Menu_pop.icons.plane.link}>
                                <img src={isHovered2 ? props.data.Menu_pop.icons.plane.imgHover : props.data.Menu_pop.icons.plane.img} alt="plane"
                                />
                            </a>
                        </button>
                        <button
                            onMouseEnter={handleMouseEnter4}
                            onMouseLeave={handleMouseLeave4}
                            onClick={() => handleDeliveryTypeChange("ship")}
                            className={deliveryType === "ship" ? "active-class" : ""}
                        >
                            <a href={props.data.Menu_pop.icons.ship.link}>
                                <img src={isHovered4 ? props.data.Menu_pop.icons.ship.imgHover : props.data.Menu_pop.icons.ship.img} alt="ship"
                                />
                            </a>
                        </button>
                    </div>
                </div>
            </div>

            {/* ПРОФИЛЬ */}
            <div className={`flex flex-col justify-between gap-[15px] ${!props.navOpen ? 'items-center' : ''}`}>
                <div className="flex items-center gap-[14px]">
                    <img src={props.data.MenuProfile.profile.image} alt="Profile" />
                    <div className={`max-w-[156px] transition-opacity duration-300 ${props.navOpen ? 'opacity-100 block' : 'opacity-0 hidden'}`} style={{ color: props.data.MenuProfile.profile.greyText }}>
                        {props.data.MenuProfile.profile.text}{props.profile.name != "" && <span style={{ color: props.data.MenuProfile.profile.blackText }}> {props.profile.name}</span>}!
                    </div>
                </div>
                <div>
                    <a href="#" className="flex items-center gap-[14px]">
                        <div className="p-[4px] rounded-[20px] inline-block"
                            style={{ background: props.data.MenuProfile.BtnInProfile.bgColor }}>
                            <img src={props.data.MenuProfile.BtnInProfile.image} alt="Profile Button" />
                        </div>
                        <div className={`transition-opacity duration-300 ${props.navOpen ? 'opacity-100 block' : 'opacity-0 hidden'}`}>
                            {props.data.MenuProfile.BtnInProfile.text}
                        </div>
                    </a>
                </div>
                <div
                    onClick={() => {
                        deleteAllCookies();
                        window.location.replace("/");
                    }}
                    className="flex items-center gap-[14px]">
                    <div className="p-[6px] rounded-[20px] inline-block"
                        style={{ background: props.data.MenuProfile.BtnExit.bgColor }}>
                        <img
                            src={props.data.MenuProfile.BtnExit.image}
                            alt="Exit Button"
                        />
                    </div>
                    <div className={`transition-opacity duration-300 ${props.navOpen ? 'opacity-100 block' : 'opacity-0 hidden'}`}>
                        {props.data.MenuProfile.BtnExit.text}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LkNav;
